
import { useEffect, useMemo, useRef, useState } from "react";
import { useCatalog } from "../../../../util/hooks/useCatalog";
import { ChangeAlertCallbackType } from "../../../Root";
import { LeadService } from "../../../../services/LeadService"

export const useLeadCount = (changeAlert: ChangeAlertCallbackType,) => {
    const [statusCatalog] = useCatalog("abb_status_lead", changeAlert);
    const leadService = useRef<LeadService>();
    const [countData, setCountData] = useState<any>();
    const [loading, setLoading] = useState(true);

    const orderedStatus = useMemo(() => {
        const orderItems = [...statusCatalog].filter(s => s.metadata.is_search).sort((a, b) => a.metadata.order > b.metadata.order ? 1 : -1)
        orderItems.push({
            value: "PM",
            name: "PM",
            metadata: {
                description: "Total PM"
            }
        })
        orderItems.push({
            value: "PFAE",
            name: "PFAE",
            metadata: {
                description: "Total PFAEs"
            }
        })
        return orderItems;
    }, [statusCatalog])



    useEffect(() => {
        leadService.current = new LeadService(changeAlert)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (statusCatalog?.length) {
            const statusFilter = statusCatalog.filter(s => s.metadata.is_search).map(s => s.name) as string[];
            const typeFilter = ["PM", "PFAE"]
            Promise.all([
                leadService.current.getLeadCountByStatus(statusFilter),
                leadService.current.getLeadCountByType(typeFilter)
            ]).then(results => {
                const dataCounters = results.map(d => d.data.content.details).flat()
                const dictionaryStatus = Object.fromEntries(dataCounters.map(d => [d.name, d.count]));
                setCountData(dictionaryStatus)

            }).catch((error) => {
                changeAlert(true, 'error', 'Error: ' + error);
            })
                .finally(() => {
                    setLoading(false)
                })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [statusCatalog])

    return { countData, orderedStatus, loading, statusCatalog }
}